import {Injectable} from '@angular/core';
import {Subject} from 'rxjs';
import {NavigationEnd, NavigationError, NavigationStart, Router} from '@angular/router';

@Injectable()
export class PageLoadingBarService {

  public loading$: Subject<boolean>;

  constructor(
    private _router: Router,
  ) {
    this.loading$ = new Subject<boolean>();

    this._router.events
      .subscribe((event: any): void => {
        if (event instanceof NavigationStart) {
          this.startLoading();
        }
        else if (event instanceof NavigationEnd || event instanceof NavigationError) {
          this.endLoading();
        }
      });
  }

  public startLoading(): void {
    this.loading$.next(true);
  }

  public endLoading(): void {
    this.loading$.next(false);
  }

}
